import React, { useState, useEffect } from "react";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase";
import * as XLSX from "xlsx";
import { fetchForms } from "../utils/forms";
import { getTenantIdFromHost } from "../Tenant/getTenantId";

const ExportData = () => {
  const tenantId = getTenantIdFromHost();
  const [forms, setForms] = useState([]);
  const [selectedSurveyId, setSelectedSurveyId] = useState("");

  //const isDev = window.location.hostname === "localhost";
  const isDev = false;

  //const [formFilter, setFormFilter] = useState(isDev ? "hidden" : "visible");
  const [formFilter, setFormFilter] = useState("visible");

  // useEffect(() => {
  //   const loadForms = async () => {
  //     const formsData = await fetchForms();
  //     setForms(formsData);
  //   };
  //   loadForms();
  // }, []);

  useEffect(() => {
    const load = async () => {
      const data = await fetchForms(formFilter);
      setForms(data);
    };
    load();
  }, [formFilter]);

  const handleExport = async () => {
    if (!selectedSurveyId) return alert("Välj en undersökning först.");

    const q = query(
      collection(db,"tenants", tenantId, "responses"),
      where("surveyId", "==", selectedSurveyId),
    );
    const snapshot = await getDocs(q);
    const data = [];

    snapshot.forEach((doc) => {
      const r = doc.data();
      data.push({
        employeeId: r.employeeId,
        ...r.responses.reduce((acc, val, i) => {
          acc[`Fråga ${i + 1}`] = val;
          return acc;
        }, {}),
      });
    });

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Svar");
    XLSX.writeFile(workbook, `survey-${selectedSurveyId}.xlsx`);
  };

  return (
    <div className="visualizeWrapper">
      <h2>Exportera svar</h2>
       {isDev && (
  <><select value={formFilter} onChange={(e) => setFormFilter(e.target.value)}>
    <option value="hidden">Hidden (testdata)</option>
    <option value="visible">Synliga</option>
    <option value="all">Alla</option>
  </select><h3>{forms.length} enkäter</h3></>
)}
      <select
        value={selectedSurveyId}
        onChange={(e) => setSelectedSurveyId(e.target.value)}
      >
        <option value="">Välj undersökning</option>
        {forms
          .map((form) => (
            <option key={form.id} value={form.id}>
              {form.formName}
            </option>
          ))}
      </select>
      <button onClick={handleExport} disabled={!selectedSurveyId}>
        Exportera till Excel
      </button>
    </div>
  );
};

export default ExportData;
